import React from "react";
import { useNavigate } from "react-router-dom";
const baseUrl = process.env.REACT_APP_API_BASE_URL;

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {

    try {
      const token = localStorage.getItem("token");
  
      if (!token) {
        throw new Error("No token found");
      }
  
      const response = await fetch(`${baseUrl}/auth/logout`, {
        method: "GET",
        headers: {
        "Authorization": `Bearer ${token}`
      }
      });
  
      const result = await response.json();
  
      if (result?.status === true) {
        alert("Logged out successfully");
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Logout failed:", result.message);
      }
    } catch (err) {
      console.error("Logout Error:", err.message);
    }

  };
  return (
    <div className="bg-yellow shadow-lg p-4 flex justify-between items-center">
      <h2 className="text-lg font-bold text-white">Dashboard</h2>
      <button onClick={handleLogout} className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg shadow-md">Logout</button>
    </div>
  );
};

export default Navbar;